export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/loading_state_complete-6e2c17e2c46621e5447dadcc1ed5d06a.svg";